(function() {
    angular
        .module("devicesModule")
        .controller("DeviceMessageBoardHistoryController", DeviceMessageBoardHistoryController)

    DeviceMessageBoardHistoryController.$inject = [
        "$rootScope",
        "$scope",
        "$state",
        "$stateParams",
        "prefs",
        "userMessagingService",
        "historyService",
        "$filter",
        "$uibModal"
    ]

    function DeviceMessageBoardHistoryController(
        $rootScope,
        $scope,
        $state, // Used in HTML
        $stateParams,
        prefs,
        userMessagingService,
        historyService,
        $filter,
        $uibModal
    ){
        "use strict"

        $rootScope.perPage = prefs.get().messageBoard.history.perPage
        $rootScope.page = 1
        $rootScope.max = 0
        $rootScope.maxPages = 1
        $rootScope.historySortTitle = "All Activity"

        $scope.startDate = ""
        $scope.endDate = new Date()

        let gotHistory = false

        const getPageCount = () => {
            $rootScope.maxPages = Math.ceil($rootScope.max / $rootScope.perPage)
        }

        const updateDisplay = (data) => {

            if (gotHistory) {

                let timezone_iana = undefined

                if ($scope.messageBoard.hasOwnProperty("device")) {
                    timezone_iana = $scope.messageBoard.device.timezone_iana
                }

                for (const item of data) {
                    item.updatedAtDisplay     = $rootScope.presentDateTime(item.updated_at, "TextLongDate", timezone_iana)
                    item.updatedAtDisplayDate = $rootScope.presentDateTime(item.updated_at, "TextShortDate", timezone_iana)
                    item.updatedAtDisplayTime = $rootScope.presentDateTime(item.updated_at, "Time", timezone_iana)
                    item.createdAtDisplay     = $rootScope.presentDateTime(item.created_at, "NumericLongDate", timezone_iana)
                }
            }
        }

        $scope.getData = () => {

            const success = (data) => {

                gotHistory = true

                if ($rootScope.historyType === "alerts") {

                    $rootScope.alertHistory = data

                } else {

                    $rootScope.allHistory = data
                    if (data.length > 0) {
                        $rootScope.exportEndDate = data[0].updated_at
                    }

                    for (const item of data) {
                        if (!item.hasOwnProperty("category") && !item.hasOwnProperty("level") && item.hasOwnProperty("updated_at")) {
                            $rootScope.exportEndDate = item.updated_at
                            break
                        }
                    }
                }

                updateDisplay(data)
                $rootScope.max = historyService.getTotalHistory()
                getPageCount()

            }

            if ($rootScope.historyType == "alerts") {
                historyService.getAlertHistory("MessageBoard", $stateParams.message_board_id, $filter("date")($scope.startDate, "yyyy-MM-dd") || "", $filter("date")($scope.endDate, "yyyy-MM-dd") || "", $rootScope.page, $rootScope.perPage).then(success)
            } else {
                historyService.getAllHistoryByDate("MessageBoard", $stateParams.message_board_id, $filter("date")($scope.startDate, "yyyy-MM-dd") || "", $filter("date")($scope.endDate, "yyyy-MM-dd") || "", $rootScope.page, $rootScope.perPage).then(success)
            }
        }

        $scope.changePerPage = (perPage) => {
            $rootScope.perPage = perPage
            $rootScope.page = 1
            getPageCount()
            $scope.getData()
            prefs.set(prefs.selectors().messageBoard.history.perPage, perPage)
        }

        $scope.changePage = (page) => {
            const newPage = $rootScope.page + page

            if (newPage > 0 && newPage <= $rootScope.maxPages) {
                $rootScope.page = newPage
                $scope.getData()
            }
        }

        $scope.changeStartDate = (date) => {
            if ($scope.startDate !== date) {
                $scope.startDate = date
                $rootScope.page = 1
            }
        }

        $scope.changeEndDate = (date) => {
            if ($scope.endDate !== date) {
                $scope.endDate = date
                $rootScope.page = 1
            }
        }

        $scope.openExportDataModal = () => {

            const failure = (error) => {
                userMessagingService.error("Failed to export Message Board History: " + error)
            }

            $uibModal.open({
                templateUrl: "app/modals/export-data-modal.view.html",
                controller: "ExportDataModalController",
                resolve: {
                    title: () => {
                        return "Message Board Telemetry"
                    },
                    exportFunction: () => {
                        return (endDate) => {
                            historyService.exportTelemetry("MessageBoard", $stateParams.message_board_id, $filter("date")(endDate, "yyyy-MM-dd") || "", failure)
                        }
                    }
                }
            }).result.catch((res) => {
                if (!(res === "cancel" || res === "escape key press")) {
                    throw res
                }
            })
        }

        $scope.$watch("retrievedMessageBoard", (retrievedMessageBoard) => {

            if (retrievedMessageBoard) {

                if ($rootScope.historyType == "alerts") {
                    updateDisplay($rootScope.alertHistory)
                } else {
                    updateDisplay($rootScope.allHistory)
                }
            }
        })

        $scope.$watch("$root.pushedData", (pushedData) => {

            if (pushedData.device.hasOwnProperty("device") && $scope.messageBoard.hasOwnProperty("device")) {

                if (pushedData.device.device.id === $scope.messageBoard.device.id) {

                    $scope.getData()

                }
            }
        })
    }
})()
